import { ShowPageLayout } from 'framework/ui/layout';
import { useCandidateService } from 'domain/shared/candidate';
import { useParams } from 'react-router-dom';
import CandidateProfile from '../shared/CandidateProfile/CandidateProfile';
import { FormShowTemplate, FormFieldsData } from 'framework/form';
import {
  buildStatusChangeTimelineNote,
  getChangedCandidateStatuses,
  getStatusChangeStateAfterSave,
} from '../shared/statusChangeHelper';

const CandidateViewPage = () => {
  const { getCompleteCandidate, updateCandidateProfile, getInlineValidationSchema, createTimelineItem } =
    useCandidateService();
  const { id } = useParams<Dictionary<string>>();

  return (
    <FormShowTemplate
      getDataFunc={() => getCompleteCandidate(id!)}
      submitFormFunc={async (values: FormFieldsData) => {
        const changedStatuses = getChangedCandidateStatuses(values);
        const comment = (values.statusChangeComment || '').trim();

        const updatedCandidate = await updateCandidateProfile(id!, values);
        const candidateAfterSave = {
          ...updatedCandidate,
          ...getStatusChangeStateAfterSave(updatedCandidate),
        };

        if (changedStatuses.length) {
          const createdTimelineNote = await createTimelineItem(id!, 'notes', {
            noteText: buildStatusChangeTimelineNote(changedStatuses, comment),
          });

          return {
            ...candidateAfterSave,
            timelineAppendRequestId: Date.now(),
            timelineAppendedItem: createdTimelineNote,
          };
        }

        return candidateAfterSave;
      }}
      getValidationSchemaFunc={getInlineValidationSchema}
      afterSubmit={{
        message: 'You are awesome! The Candidate has been successfully saved.',
      }}
    >
      <ShowPageLayout hasSeparateSections>
        <CandidateProfile />
      </ShowPageLayout>
    </FormShowTemplate>
  );
};

export default CandidateViewPage;
